<template>
  <div>
    <datatable
      title="Company Employees"
      @create="createCompanyEmployee"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-employees',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'resource.id'
        },
        {
          name: 'first_name',
          value: 'first_name'
        },
        {
          name: 'last_name',
          value: 'last_name'
        },
        {
          name: 'phone_number',
          value: 'phone_number'
        },
        {
          name: 'email',
          value: 'email'
        },
        {
          name: 'status',
          value: 'status'
        }
      ],
      data: [],
      operations: [],
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils.getCompanyEmployees({ company_id: this.company_id })
        .then(response => {
          this.data = response
        })
    },
    createCompanyEmployee () {
      this.create({
        designator: 'register-company-employee-form',
        component_name: 'CompanyEmployeesForm',
        is_create: true,
        company_id: this.company_id,
        modal_title: 'Create Company Employee'
      })
    },
    editClick (data) {
      this.create({
        designator: 'company-employees-form-modal',
        component_name: 'CompanyEmployeesForm',
        data,
        modal_title: data.first_name + ' - ' + data.last_name
      })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
<style scoped></style>
